module.exports = __webpack_public_path__ + "img/daffodil-helpingfamilyfriends.93d31b35.png";